import { ApiGetRequest } from './api-get-request';
import { ApiParameters } from './api-parameters';

export class AuthorizeWithStateRequest extends ApiGetRequest
{
    public constructor(state: string, webapiBasepath: string)
    {
        const parameters = new ApiParameters();
        parameters.addQueryParameter('state', state);

        super('/authorize/authorize', parameters, null, webapiBasepath);
    }
}
